import { filter } from 'lodash';

import type { Skill } from 'bundles/browse-common/legacy/components/Domain/types/Skill';
import getSubDomainSkillsData from 'bundles/browse/components/Domain/constants/subDomainSkillsData';

export const getSkillsForSubDomain = (subDomainId: string): Array<Skill> => {
  const subDomainSkills = filter(getSubDomainSkillsData(), ['subDomainId', subDomainId]);
  return subDomainSkills;
};
